<template>
  <!-- 隐患分类管理 -->
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-page-header
          @back="$Common.pageJump('/hidden_danger_data', 3)"
          content="隐患分类"
        >
        </el-page-header>
      </div>
      <div class="search_box">
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-circle-plus-outline"
          @click="dialog = true"
          >新增隐患分类</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="dataList.content"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column label="序号" width="70" align="center">
            <template v-slot="scope">
              {{
                requestParams.pageSize * (requestParams.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>

          <el-table-column
            prop="hiddenDangerClassifyName"
            label="分类名称"
            align="center"
          >
          </el-table-column>

          <el-table-column label="创建日期" align="center" width="200">
            <template slot-scope="scope">
              {{ $Common.dateFormatDate(scope.row.hiddenDangerAddtime) }}
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-link
                type="primary"
                v-show="scope.row.hiddenDangerClassifyOperation == 1"
                @click="delHiddenDangerClassification(scope.row)"
                :underline="false"
                >删除</el-link
              >
              <!-- <el-link
                type="primary"
                v-show="scope.row.hiddenDangerClassifyOperation == 0"
                :underline="false"
                >预设分类</el-link
              > -->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination_box">
        <el-pagination
          @current-change="dangerCatePage"
          :current-page="requestParams.pageNum"
          :page-size="requestParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="dataList.totalSize"
        >
        </el-pagination>
      </div>

      <!-- 新增隐患分类 -->
      <el-dialog
        :before-close="cancelForm"
        :visible.sync="dialog"
        direction="ltr"
        custom-class="demo-drawer"
        ref="drawer"
        append-to-body
         width="800px"
        size="30%"
        title="新增隐患分类"
        :wrapperClosable="false"
        :close-on-press-escape="false"
      >
        <div class="demo-drawer__content ">
          <div class="inside_pages_right_form_title">
            新增隐患分类
          </div>
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-2 control-label">分类名称</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="dangerCateFromData.hiddenDangerClassifyName"
                  placeholder="分类名称"
                />
              </div>
            </div>

            <div class="form-group">
              <div class="col-sm-offset-2 col-sm-10">
                <el-button
                  type="primary"
                  @click="addHiddenDangerClassification"
                  size="mini"
                  >确定提交</el-button
                >
                <el-button @click="dialog = false" size="mini">取消</el-button>
              </div>
            </div>
          </form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      // 隐患分类formData
      dangerCateFromData: {
        hiddenDangerClassifyName: "",
        schoolId: this.$store.state.schoolId
      },
      dialog: false,
      // 数据列表
      dataList: {
        pageNum: 1, // 第几页
        pageSize: 20, // 一页多少个
        totalSize: 0, // 总条数
        totalPages: 0, // 总页数
        content: [] // 数据列表
      },
      // 请求数据
      requestParams: {
        schoolId: this.$store.state.schoolId,
        pageNum: 1,
        pageSize: 20,
        searchValue: "",
        dailyTaskName: "", // 巡查任务
        regionalPatrolSite: "", // 巡查点
        supervisorsStatus: "" // 巡查状态
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    cancelForm() {
      this.dialog = false;
      clearTimeout(this.timer);
    },

    // 获取隐患分类
    async getHiddenDangerClassification() {
      var newParamData = {
        schoolId: this.requestParams.schoolId,
        pageNum: this.requestParams.pageNum,
        pageSize: this.requestParams.pageSize
      };
      let res = await this.$Http.getHiddenDangerClassification(
        newParamData,
        true
      );
      // console.log(res)

      if (res.code == 200) {
        this.dataList.pageNum = res.data.pageNum;
        this.dataList.pageSize = res.data.pageSize;
        this.dataList.totalPages = res.data.totalPages;
        this.dataList.totalSize = res.data.totalSize;
        this.dataList.content = res.data.content;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 隐患分类翻页
    dangerCatePage(val) {
      this.requestParams.pageNum = val;
      this.getHiddenDangerClassification();
      console.log(`当前页: ${val}`);
    },
    // 新增隐患分类
    async addHiddenDangerClassification() {
      let res = await this.$Http.addHiddenDangerClassification(
        this.dangerCateFromData,
        true
      );
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "隐患分类添加成功"
        });
        this.getHiddenDangerClassification();

        this.cancelForm();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 删除隐患分类
    delHiddenDangerClassification(thisData) {
      this.$confirm("此操作将永久删除此条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        let requestData = {
          hiddenDangerId: thisData.hiddenDangerId
        };
        let res = await this.$Http.delHiddenDangerClassification(
          requestData,
          true
        );
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getHiddenDangerClassification();
        } else if (res.code == 101) {
        } else {
          this.$message({
            type: "error",
            message: res.messsage
          });
        }
      });
    }
  },
  created() {},
  mounted() {
    this.getHiddenDangerClassification();
  }
};
</script>
<style scoped></style>
